import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { NavigationMenu } from '@/components/design-system/molecules/navigation-menu';
import { Divider } from '@/components/design-system/atoms/divider';
import { BottomSection } from './BottomSection';

// eslint-disable-next-line no-shadow
export enum AdminRoutes {
  // Global
  People = 'People',
  Contracts = 'Contracts',
  Rents = 'Rents',
  Transactions = 'Transactions',
  Dashboard = 'Dashboard',
  CommunityBroadcastMessages = 'CommunityBroadcastMessages',
  Stats = 'Stats',
}

// Give me on object that has a string value for each key in AdminRoutes  (e.g. { People: 'People', Contracts: 'Contracts', ... })

const AdminSideNavigation: React.FC<{
  tabToSet: AdminRoutes;
}> = ({ tabToSet }) => {
  const [selectedTab, setSelectedTab] = useState<AdminRoutes>(tabToSet);
  const { t } = useTranslation();

  return (
    <NavigationMenu onChange={setSelectedTab} activeNavigationKey={selectedTab}>
      <NavigationMenu.NavigationMenuTabs>
        <NavigationMenu.NavigationMenuTab
          iconName="element-2"
          navigationKey={AdminRoutes.Dashboard}
          href="./dashboard"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.Dashboard.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="element-2"
          navigationKey={AdminRoutes.Stats}
          href="./stats"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.Stats.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="home"
          navigationKey={AdminRoutes.Contracts}
          href="./contracts"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.Contracts.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="arrow-3"
          navigationKey={AdminRoutes.Transactions}
          href="./transactions"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.Transactions.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="receipt-1"
          navigationKey={AdminRoutes.Rents}
          href="./new-rents"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.Rents.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="message"
          navigationKey={AdminRoutes.CommunityBroadcastMessages}
          href="./community-broadcast-messages"
        >
          {t(
            `js.features.admin.shared.navigation.${AdminRoutes.CommunityBroadcastMessages.toLowerCase()}`
          )}
        </NavigationMenu.NavigationMenuTab>
        <NavigationMenu.NavigationMenuTab
          iconName="people"
          navigationKey={AdminRoutes.People}
          href="./colocs"
        >
          {t(`js.features.admin.shared.navigation.${AdminRoutes.People.toLowerCase()}`)}
        </NavigationMenu.NavigationMenuTab>
      </NavigationMenu.NavigationMenuTabs>
      <div className="px-7">
        <Divider />
      </div>
      <BottomSection />
    </NavigationMenu>
  );
};

export { AdminSideNavigation };
